import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Switch } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import ERP from "../../../../../utils/ErpService";

export default function VntVendedoresForm(props) {
  const { record, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.vnd_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [activo, setActivo] = useState(record.vnd_id > 0 ? record.vnd_activo : 0);

  useEffect(() => {
    setCurId(record.vnd_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await ERP.sendVntVendedores(
      currentUser,
      curId,
      activo,
      "VntVendedores",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE AGENTES VENDEDORES",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE AGENTES VENDEDORES",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="VntVendedores"
      onFinish={guardarCambios}
      initialValues={{
        vnd_codigo: record.vnd_id > 0 ? record.vnd_codigo : "",
        vnd_nombre: record.vnd_id > 0 ? record.vnd_nombre : "",
        vnd_comision: record.vnd_id > 0 ? record.vnd_comision : "",
        vnd_activo: record.vnd_id > 0 ? record.vnd_activo : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.vnd_id > 0
            ? "ACTUALIZAR AGENTES VENDEDORES"
            : "AGREGAR AGENTES VENDEDORES"}
        </Title>
      </Form.Item>
      <Form.Item
        name="vnd_codigo"
        label="Codigo"
        rules={[
          {
            required: true,
            message: "El codigo es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase", width: "100px" }}
          value={record.vnd_id > 0 ? record.vnd_codigo : ""}
          disabled={record.vnd_id > 0 ? 1 : 0}
        />
      </Form.Item>
      <Form.Item
        name="vnd_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.vnd_id > 0 ? record.vnd_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="vnd_comision"
        label="% comision"
      >
        <Input
          style={{ textTransform: "uppercase", width: "170px" }}
          value={record.vnd_id > 0 ? record.vnd_comision : ""}
        />
      </Form.Item>
      <Form.Item
        name="vnd_activo"
        label="Activo:"
        wrapperCol={{ span: 15}}
        style={{ display: "flex", flexDirection: "row" }}
      >
        <Space direction="horizontal" size={43}>
          <Switch
            checked={activo}
            onChange={(val) => setActivo(val ? 1 : 0)}
            checkedChildren="SI"
            unCheckedChildren="NO"
            defaultChecked
          />  
        </Space>
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
